/* eslint-disable */
import { getEncoding, getEncodingNameForModel } from "js-tiktoken"

class TokenService {
  private static instance: TokenService
  private encoder: any

  private constructor() {
    this.encoder = getEncoding(getEncodingNameForModel("gpt-4-0125-preview"))
  }

  public static getInstance(): TokenService {
    if (!TokenService.instance) {
      TokenService.instance = new TokenService()
    }

    return TokenService.instance
  }

  public countTokens(text: string): number {
    const tokens = this.encoder.encode(text)
    return tokens.length
  }
}

export default TokenService
